// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_nh-0";
export var discountCodeInput = "_nh-1";